<template>
  <div>
    <sys-data-table
      v-model="selecionados"
      :headers="headers"
      :items="desserts"
      :search="pesquisar"
      :fixed-header="true"
      :height="alturaDaJanela - 170"
      :item-height="35"
      :loading="loading"
      item-key="idproduto"
      show-select
    >
      <template #top>
        <v-spacer />

        <v-text-field
          v-model="pesquisar"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          clearable
          outlined
          hide-details
          class="my-2"
          style="max-width: 450px;"
        />

        <NovoMenu
          @atualizar-tela-inicial-menu-configuracao-menu="atualizarMenus()"
        />
      </template>

      <template #item.editar="{ item }">
        <EditarMenu
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-menu="atualizarMenus()"
        />
      </template>

      <template #item.deletar="{ item }">
        <DeletarMenu
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-menu="atualizarMenus()"
        />
      </template>

      <template #item.icone="{ item }">
        <v-icon>{{ item.icone }}</v-icon>
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import NovoMenu from './Dialog/NovoMenu.vue';
import EditarMenu from './Dialog/EditarMenu.vue';
import DeletarMenu from './Dialog/DeletarMenu.vue';

import Responsividade from '@/helpers/ResponsiveHeight';
import { buscarMenusConfiguracaoMenuParametrizacao } from '../Api';
export default {
  components: {
    NovoMenu,
    EditarMenu,
    DeletarMenu
  },
  mixins: [Responsividade],
  data: () => ({
    headers: [
      { text: 'ID', value: 'id', style: { width: '50px' }},
      { text: 'Modulo', value: 'descricao_modulo' },
      { text: 'Menu', value: 'descricao' },
      { text: 'Url', value: 'url' },
      { text: 'Icone', value: 'icone', style: { width: '50px' }},
      { text: 'Ordem', value: 'ordem', style: { width: '60px' }},
      { text: '', value: 'editar', style: { width: '35px' }},
      { text: '', value: 'deletar', style: { width: '35px' }},
    ],
    desserts: [],
    pesquisar: '',
    selecionados: [],
    loading: false
  }),
  mounted() {
    this.buscarMenus();
  },
  methods: {
    buscarMenus() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarMenusConfiguracaoMenuParametrizacao()
          .then((menus) => this.desserts = menus)
          .catch(() => this.Helpers.logout())
          .finally(() => this.loading = false)
      )
    },
    atualizarMenus() {
      this.desserts = [];
      this.loading = true;
      this.buscarMenus();
    }
  }
}
</script>

<style>

</style>
